import { render, staticRenderFns } from "./supportKnowledge.vue?vue&type=template&id=1d36b05c&scoped=true&"
import script from "./supportKnowledge.vue?vue&type=script&lang=js&"
export * from "./supportKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d36b05c",
  null
  
)

export default component.exports